import * as Sentry from '@sentry/react'

import {
  ErrorContext,
  sentryCaptureExceptionShared,
  SentrySDK,
} from '@lyrahealth-inc/shared-app-logic/src/features/sentry/utils'

/**
 * NOTE: ONLY use for native exceptions OR for very rare cases, not javascript exceptions
 * We want to ONLY call to sentry when there are exceptions that may affect the app natively.
 *
 * Explicitly logging to Sentry for errors or debug related messages that are not app crashes can bloat the Sentry Dashboard
 * making it hard for us to tackle errors in a meaningful way
 *
 * Attempt to log exception explicitly to Sentry
 * @param err The error to capture
 * @param extras Additional context for the error
 * @returns The Sentry event ID
 */
export const sentryCaptureException = (err: Error, extras: ErrorContext): string => {
  // Use type assertion to handle the type mismatch between different Sentry SDK versions
  return sentryCaptureExceptionShared(Sentry as SentrySDK, err, extras)
}
